import template from './loansDetailMinimumFee.html';
import controller from './loansDetailMinimumFee.controller';
import './loansDetailMinimumFee.scss';

let loansDetailMinimumFeeComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    onClick: '&',
    minimumFee: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansDetailMinimumFeeComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailMinimumFee/loansDetailMinimumFee.component.js